(function () {
  try {
    var IDLE_TIMEOUT_MS = 10000;
    var MAX_RETRIES = 2;
    var RETRY_KEY = 'pulse_bootstrap_retries';

    var retries = 0;
    try {
      retries = parseInt(sessionStorage.getItem(RETRY_KEY) || '0', 10);
      if (isNaN(retries)) { retries = 0; }
    } catch (e) {
      // sessionStorage unavailable (e.g. private mode restrictions) — degrade silently
      return;
    }

    // Stop watching if max retries already exhausted
    if (retries >= MAX_RETRIES) {
      return;
    }

    function startWatchdog() {
      try {
        if (!document.body) { return; }

        var timer = setTimeout(function () {
          try {
            if (!document.body.classList.contains('hide-loader')) {
              try {
                sessionStorage.setItem(RETRY_KEY, retries + 1);
              } catch (e) { /* ignore storage errors */ }
              window.location.reload(true);
            }
          } catch (e) { /* ignore timer callback errors */ }
        }, IDLE_TIMEOUT_MS);

        // Cancel the reload once Angular bootstraps successfully
        var observer = new MutationObserver(function () {
          try {
            if (document.body.classList.contains('hide-loader')) {
              clearTimeout(timer);
              try {
                sessionStorage.removeItem(RETRY_KEY);
              } catch (e) { /* ignore storage errors */ }
              observer.disconnect();
            }
          } catch (e) {
            // If observer callback throws, disconnect to avoid repeated errors
            try { observer.disconnect(); } catch (e2) { /* ignore */ }
            clearTimeout(timer);
          }
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

      } catch (e) { /* startWatchdog failed — degrade silently, do not block app */ }
    }

    // Ensure document.body is available before observing
    if (document.body) {
      startWatchdog();
    } else {
      document.addEventListener('DOMContentLoaded', startWatchdog);
    }

  } catch (e) { /* outer guard — nothing in this script should ever break the app */ }
})();
